module.exports = __webpack_public_path__ + "725fa5812a31ae3e3301ea135c3b283d.png";